<script setup>
import TextInput from '@/Components/Input/TextInput.vue';
import { reactive } from 'vue';
import PrimaryButton from '@/Components/Button/PrimaryButton.vue';
import { IpAddress, IpRange } from 'cidr-calc';

import Card from '@/Components/Card/Card.vue';
import { TOOL_CIDR_CALCULATOR, captureToolUsed } from '@/Common/Posthog.js';

const form = reactive({
  firstIp: '',
  lastIp: ''
});

const state = reactive({
  firstIp: null,
  lastIp: null,
  ranges: null
});

function submit() {
  state.firstIp = form.firstIp;
  state.lastIp = form.lastIp;
  state.ranges = null;

  try {
    state.ranges = new IpRange(
      IpAddress.of(state.firstIp),
      IpAddress.of(state.lastIp)
    )
      .toCidrs()
      .map(formatCidr);

    captureToolUsed({
      tool: TOOL_CIDR_CALCULATOR,
      properties: { mode: 'range_to_cidr' }
    });
    // eslint-disable-next-line
  } catch (e) {
    // no-op
  }
}

function formatCidr({ prefix, prefixLen }) {
  return `${prefix.bytes.join('.')}/${prefixLen}`;
}
</script>

<template>
  <form
    class="flex grow flex-col gap-4 md:flex-row md:items-center"
    @submit.prevent="submit"
  >
    <TextInput
      v-model.trim="form.firstIp"
      size="large"
      :label="$t('cidr_calculator.partials.ip_to_cidr_form.first_ip_address')"
      description="e.g. 127.0.0.0"
      :placeholder="
        $t('cidr_calculator.partials.ip_to_cidr_form.enter_first_ip_address')
      "
    />
    <TextInput
      v-model.trim="form.lastIp"
      size="large"
      :label="$t('cidr_calculator.partials.ip_to_cidr_form.last_ip_address')"
      description="e.g. 127.0.0.128"
      :placeholder="
        $t('cidr_calculator.partials.ip_to_cidr_form.enter_last_ip_address')
      "
    />
    <div class="flex items-center md:mt-2">
      <PrimaryButton size="large">
        {{ $t('cidr_calculator.partials.ip_to_cidr_form.calculate') }}
      </PrimaryButton>
    </div>
  </form>

  <Teleport v-if="state.ranges !== null" to="#results">
    <Card>
      <div class="flex flex-row gap-3">
        <div class="font-bold">
          {{
            $t('cidr_calculator.partials.ip_to_cidr_form.range', {
              first_ip: state.firstIp,
              last_ip: state.lastIp
            })
          }}
        </div>
        <div class="flex flex-col">
          <div
            class="font-normal"
            v-for="(range, key) in state.ranges"
            :key="key"
          >
            {{ range }}
          </div>
        </div>
      </div>
    </Card>
  </Teleport>
</template>
